module.exports = __webpack_public_path__ + "img/bannerTop.51e6868a.png";